@if (initialized) {
<div class="">
  <p-carousel [value]="infoSteps" [numVisible]="1" [numScroll]="1"
              (onPage)="handleCarouselPageChange($event)"
              indicatorStyleClass="custom-indicator">
    <ng-template let-info pTemplate="item">
      <div class="product-item">
        <div class="product-item-content">
          <div class="mb-3 text-center">
            <img class="md:w-20rem w-14rem" [src]="info.uiImageUrl"/>
          </div>
          <div class="text-center max-w-75rem mx-auto">
            <h4>{{ info.uiHeader }}</h4>
            <h6 class="mt-0 mb-3">{{ info.uiDescription }}</h6>
            <div class="mt-5 flex align-items-center justify-content-center gap-2">
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>
}
